module.exports = __webpack_public_path__ + "static/img/acil.2409fa95.svg";